<template>
    <div class="dashboard">
        <b-card>
            <template #header>
                <h1 class="mb-0">Due Dates</h1>
            </template>

            <b-card-body class="row pl-1">
                <app-timeline>
                    <app-timeline-item 
                        v-for="item in dueDates" :key="item.type" 
                        :class="item.type.replaceAll(' ', '')" 
                        icon="CalendarIcon"
                        :fill-border="true"
                    >
                        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                            <h2 class="pt-0 mt-0">
                                {{ item.type }}
                                <span v-if="item.short_type"> ("{{  (item.short_type) }}")</span>
                            </h2>
                        </div>

                        <p>{{ item.description }}</p>

                        <p class="mb-0">
                            Due by:
                            <strong class="align-bottom text-primary">
                                {{ formatDate(item.due_date) }}
                            </strong>
                        </p>
                    </app-timeline-item>
                </app-timeline>
            </b-card-body>
        </b-card>

    </div>
</template>

<script>
import {
    BCard,
    BCardBody,
} from 'bootstrap-vue';
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue';
import Dashboard from '@/models/Dashboard';
import { formatDate } from '@/helpers';

export default {
    components: {
        BCard,
        BCardBody,
        AppTimeline,
        AppTimelineItem
    },
    
    data() {
        return {
            dueDates: {}
        };
    },

    mounted()
    {
        // just to make sure the menu bar is shown
        this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false);
        this.$store.commit('cart/CLEAR');
        this.$store.commit('company/UPDATE_CURRENT_ONBOARDING_PAGE', '');
    },
    
    async created() 
    {
        const data = await Dashboard.requestData();
        this.dueDates = data.due_dates;
    },
    
    methods: {
        formatDate(date) {
            return formatDate(date);
        },

        getStatus(dueIn) {
            if (dueIn <= 10)
                return 'danger';
            if (dueIn <= 15)
                return 'warning';
            return 'primary';
        },
        
        getStatusInHex(dueIn) {
            if (dueIn <= 10)
                return '#ea5455';
            if (dueIn <= 15)
                return '#ff9f43';
            return '#4267B2';
        },
    } 
};
</script>

<style>
    .w-24 {
        width: 24%;
    }
    
    [dir] .card .card.border-right-primary {
        border-left-color: #4267B2;
    }
    
    .dashboard .app-timeline li:last-child:after {
        display: none;
    }
</style>